import { ApplicationState } from "@redux/reducers";
import isNil from "lodash/isNil";

export const isEmbeddedView = (state: ApplicationState) => !isNil(state.appState.appConfiguration.embedAuthToken);
